import { useTranslation } from "react-i18next";
import { IdeaCard } from "@/components/Idea/IdeaCard.tsx";
import { Idea } from "@/api/types.ts";
import "./styles.css";
import {Section} from "@telegram-apps/telegram-ui";

export const Recos = ({ ideas }: { ideas: Idea[] }) => {
  const { i18n: { language } } = useTranslation();

  if (ideas.length === 0) {
    return null;
  }

  return (
    <div>
      {language.toLocaleLowerCase().includes('ru') && (
        <div className="recos-section">
          {/* Section header */}
          <Section.Header>Вам может понравиться</Section.Header>

          {/* Horizontal scroll container */}
          <div className="horizontal-scroll-container overflow-x-auto px-2 pb-2 scrollbar-hide">
            <div className="flex gap-3 snap-x snap-mandatory scroll-smooth items-center">
              {ideas.map((idea) => (
                <div key={"recommended_idea_" + idea.id} className="snap-start">
                  <IdeaCard idea={idea} layout="horizontal-scroll" />
                </div>
              ))}
              {/*<div className="snap-start">*/}
              {/*  <ViewAllButton />*/}
              {/*</div>*/}
            </div>
          </div>

          {/* Section footer */}
          <Section.Footer>Идеи от сервиса @wishapp</Section.Footer>
        </div>
      )}
    </div>
  );
};